"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _SpinTable = _interopRequireDefault(require("./SpinTable.js"));
var _SpinErrorTable = _interopRequireDefault(require("./SpinErrorTable.js"));
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
var _reactResponsive = _interopRequireDefault(require("react-responsive"));
var _Card = require("material-ui/Card");
var _i18next = _interopRequireDefault(require("i18next"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SpinReportCardContent = /*#__PURE__*/function (_React$Component) {
  _inherits(SpinReportCardContent, _React$Component);
  var _super = _createSuper(SpinReportCardContent);
  function SpinReportCardContent(props) {
    var _this;
    _classCallCheck(this, SpinReportCardContent);
    _this = _super.call(this, props);
    _this.setopenClose = function () {
      if (!_this.state.openClose) {
        _this.setState({
          openClose: true
        });
        _this.forceUpdate();
      } else {
        _this.setState({
          openClose: false
        });
        _this.forceUpdate();
      }
    };
    _this.getCorlorCodForGrade = function (grade) {
      if (grade === 'A') return '#7ED321';
      if (grade === 'B') return '#7ED321';
      if (grade === 'C') return '#FFC814';
      if (grade === 'D') return '#FE8F40';
      if (grade === 'E') return '#FF4E3E';
    };
    _this.onCardClick = function (val, obj) {
      var activityTrack = [];
      if (localStorage.getItem('activityTrack')) activityTrack = JSON.parse(localStorage.getItem('activityTrack'));
      var index = _this.state.summaryRange.indexOf(obj);
      for (var i = 0; i < _this.state.summaryRange.length; i++) {
        if (i == index) {
          if (_this.state.summaryRange[i].expandFlag === true) _this.state.summaryRange[i].expandFlag = false;else {
            var _activityTrack = [];
            if (localStorage.getItem('activityTrack')) _activityTrack = JSON.parse(localStorage.getItem('activityTrack'));
            var track = {
              hit_timestamp: (0, _moment["default"])().format(),
              session_id: localStorage.getItem("token"),
              userid: localStorage.getItem("username"),
              deviceInfo: JSON.parse(localStorage.getItem("deviceInfo")),
              hit_page: 'ReportCard',
              hit_type: 'ReportCardCategoryExpand',
              hit_attribute1: obj.category,
              hit_attribute2: obj.grade,
              hit_attribute3: _this.props.summaryInfo.points,
              hit_attribute4: _this.props.summaryInfo.medal,
              hit_attribute5: ''
            };
            _activityTrack.push(track);
            localStorage.setItem('activityTrack', JSON.stringify(_activityTrack));
            _this.state.summaryRange[i].expandFlag = true;
          }
        } else {
          _this.state.summaryRange[i].expandFlag = false;
        }
      }
      _this.forceUpdate();
      _this.setState({
        category: obj.category
      });
      _this.setopenClose();
    };
    _this.state = {
      category: "",
      openClose: false,
      summaryRange: props.summaryRange,
      playerStatistics: props.playerStatistics
    };
    return _this;
  }
  _createClass(SpinReportCardContent, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        playerStatistics: nextProps.playerStatistics
      });
      this.setState({
        summaryRange: nextProps.summaryRange
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row hide-prop_heading dimgreyBorderBottom",
        style: {
          margin: '0px 10px 10px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-4 columnTitlesOfMGA",
        style: {
          width: '31%',
          marginLeft: '-16px'
        }
      }, _i18next["default"].t("lable.Title")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-5",
        style: {
          fontFamily: 'Roboto',
          width: '46%',
          marginLeft: '0px',
          color: '#b0b0b0'
        }
      }, _i18next["default"].t("lable.Description")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-1",
        style: {
          fontFamily: 'Roboto',
          width: '8%',
          marginLeft: '34px',
          color: '#b0b0b0'
        }
      }, _i18next["default"].t("lable.Lesson"), "\xA0", _i18next["default"].t("lable.Grade"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "stats_table_wrapper"
      }, this.state.summaryRange.map(function (obj, index) {
        return /*#__PURE__*/_react["default"].createElement(_Card.Card, {
          className: "spin-cards",
          key: index,
          expanded: obj.expandFlag !== undefined ? obj.expandFlag : false
        }, /*#__PURE__*/_react["default"].createElement("div", {
          onClick: function onClick() {
            return _this2.onCardClick(index + 1, obj);
          }
        }, /*#__PURE__*/_react["default"].createElement(_Card.CardHeader, {
          style: {
            padding: '16px 0px'
          },
          actAsExpander: true,
          showExpandableButton: false,
          iconStyle: {
            display: 'none'
          }
        }, /*#__PURE__*/_react["default"].createElement(CardHeaderContent, {
          className: "common_CardHeaderContent",
          expandFlag: obj.expandFlag,
          title: obj.category,
          subtitle: obj.comment,
          toolTip: obj.toolTip,
          grade: obj.grade && obj.grade,
          colorCode: _this2.getCorlorCodForGrade(obj.grade && obj.grade),
          openClose: _this2.state.openClose,
          setopenClose: _this2.setopenClose,
          isErrorTable: _this2.props.isErrorTable
        }))), /*#__PURE__*/_react["default"].createElement(_Card.CardText, {
          expandable: true,
          style: {
            padding: '0px',
            marginTop: '-8px'
          }
        }, _this2.props.isErrorTable ? /*#__PURE__*/_react["default"].createElement(_SpinErrorTable["default"], {
          i18next: _i18next["default"],
          category: _this2.state.category,
          ismodal: false,
          errorHands: _this2.props.summaryRange.filter(function (obj) {
            return obj.category === _this2.state.category;
          })[0],
          handReplayerOpen: function handReplayerOpen(item) {
            return _this2.props.handReplayerOpen(item);
          }
        }) : /*#__PURE__*/_react["default"].createElement(_SpinTable["default"], {
          i18next: _i18next["default"],
          className: "common_PlayerStatsTable",
          isLiveview: _this2.props.isLiveview,
          path: _this2.props.path,
          summaryInfo: _this2.props.summaryInfo,
          category: _this2.state.category,
          errorSummary: _this2.props.errorSummary,
          biggestErrorBySituations: _this2.props.biggestErrorBySituations,
          playerStatistics: _this2.state.playerStatistics,
          handsAnalysed: _this2.props.handsAnalysed,
          accountName: _this2.props.accountName,
          isErrorTable: _this2.props.isErrorTable,
          handReplayerOpen: function handReplayerOpen(item) {
            return _this2.props.handReplayerOpen(item);
          }
        })));
      })));
    }
  }]);
  return SpinReportCardContent;
}(_react["default"].Component);
var CardHeaderContent = function CardHeaderContent(props) {
  return /*#__PURE__*/_react["default"].createElement("table", {
    className: "resp-table dimgreyBorderBottom",
    style: {
      width: "100%",
      marginTop: '-30px',
      marginBottom: '-10px',
      color: "#020202",
      backgroundColor: "white"
    }
  }, /*#__PURE__*/_react["default"].createElement("tbody", {
    "data-e2e": "categoryTable"
  }, /*#__PURE__*/_react["default"].createElement("tr", {
    className: "categoryTable_data",
    style: {
      backgroundColor: "#fff !important"
    }
  }, /*#__PURE__*/_react["default"].createElement("td", {
    className: "categoryTable_title spin-stats-title",
    style: {
      width: '23.7%',
      whiteSpace: 'pre-wrap',
      borderBottom: 'none',
      textTransform: 'capitalize'
    }
  }, _i18next["default"].t("lable." + props.title), "\xA0", props.isErrorTable && /*#__PURE__*/_react["default"].createElement("i", {
    style: {
      color: '#DE460F'
    },
    className: "fa fa-question-circle",
    "data-tip": true,
    "data-for": "SpinMyBiggestErrors".concat(props.title),
    "aria-hidden": "true"
  }), /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
    id: "SpinMyBiggestErrors".concat(props.title),
    type: "warning",
    place: "bottom",
    effect: "solid",
    className: "livefeedStat_cust_tooltip SpinMyBiggestErrors_cust_tooltip"
  }, /*#__PURE__*/_react["default"].createElement("span", null, props.toolTip))), /*#__PURE__*/_react["default"].createElement("td", {
    style: {
      width: props.isErrorTable ? '59%' : '58%',
      whiteSpace: 'pre-wrap',
      borderBottom: 'none'
    },
    className: "hide-prop resp-table-td spin-stats-description"
  }, props.subtitle), /*#__PURE__*/_react["default"].createElement("td", {
    style: {
      width: '8%',
      marginRight: '10px',
      whiteSpace: 'initial',
      borderBottom: 'none',
      fontFamily: 'Roboto'
    },
    className: "resp-padding"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "cursive",
    style: {
      color: props.colorCode,
      fontSize: '28px',
      fontWeight: 'bold'
    }
  }, props.grade)), /*#__PURE__*/_react["default"].createElement("td", {
    style: {
      width: '12%',
      borderBottom: 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    "data-e2e": "openClick",
    className: 'mg-btn saffron greyBtnLiveReport btnHalo livestateTable_collapse_btn ' + (props.expandFlag ? "closeButtonhoverEffect" : ""),
    style: {
      width: "80px",
      height: '33px',
      "float": 'right',
      backgroundColor: props.expandFlag ? "#FFFFFF" : "#e8490d",
      color: props.expandFlag ? "#e8490d" : "#FFFFFF"
    },
    onClick: function onClick() {
      return props.setopenClose();
    }
  }, props.expandFlag ? _i18next["default"].t("lable.CLOSE") : _i18next["default"].t("lable.OPEN"))))));
};
var _default = SpinReportCardContent;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/SpinReportCardContent.js
 ** module id = 2401
 ** module chunks = 0
 **/